export const INSURANCE_TYPE_ASSIGNED = 'INSURANCE_TYPE_ASSIGNED';
export const INSURANCE_TYPES = { INSURED: 'INSURED', VEHICLE: 'VEHICLE' };
